import React from "react";
import { useTranslation } from "react-i18next";
import { Container, Title, Text, Image } from "./Modal.styles";
import modalImage from "../../assets/images/modalImage.png";

const Modal = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <div>
        <Title>{t("thankYou")}</Title>
        <Text>{t("messageSent")}</Text>
      </div>
      <Image src={modalImage} alt="modal image"></Image>
    </Container>
  );
};

export default Modal;
